/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main__subtitle,.main__title{color:#06c;font-family:\"Berthold Imago\";font-weight:700;text-align:center}.main__title{font-size:42px;margin-bottom:0}.main__subtitle{font-size:16px;margin-bottom:50px;margin-top:50px}.main .error{align-items:center;flex:2}.main .error .error-message{color:#c03;font-size:16px;text-align:center}.main .link{flex:2;text-align:center}.main .link a{font-size:small;color:#06c;text-decoration:underline}"];
export { styles as styles };
